import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Malebtn from "../assets/male_btn.png";
import Femalebtn from "../assets/female_btn.png";

import ttsAudio from "../assets/sound/tts_03.mp3"; // mp3 경로 import

const About1_1 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();

    const audioRef = useRef(null);


    const [tody,SetToday]=useState();

    const clickNext= item => {

        navigate('/about1/'+name+'/'+item);
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />
            
            <div className="input-area">
                <div className="step_area">
                    STEP 2
                </div>
                <div className="title_area">
                    <h1 className="num_title">(2/4)</h1>
                    <h2 className="title">성별을 선택해주세요</h2>
                </div>

                <div className="input_section" style={{background:"#ffffff"}}>
                    <div className="flex_area">
                        <ul>
                            <li>
                                <button className="checkBtn male" onClick={() => clickNext('1')}></button>
                            </li>
                            <li>
                                <button className="checkBtn female" onClick={() => clickNext('2')}></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About1_1;
